import type { TkDict } from "./types";

const dict: TkDict = {
  uz: {
    "tk.dash.new": "Yangi taklifnoma",
    "tk.dash.my": "Taklifnomalarim",
    "tk.dash.this_invitation": "Ushbu taklifnoma",
    "tk.dash.overview": "Umumiy ko'rinish",
    "tk.dash.wishes": "Tilaklar",
    "tk.dash.link": "Havola",
    "tk.dash.share": "Ulashish",
    "tk.nav.home_aria": "bosh sahifa",
    "tk.nav.how": "Qanday ishlaydi",
    "tk.nav.pricing": "Narx",
    "tk.nav.faq": "Savollar",
    "tk.nav.cabinet": "Kabinet",
    "tk.nav.create": "Taklifnoma yaratish",
    "tk.nav.open_menu": "Menyuni ochish",
    "tk.nav.close_menu": "Menyuni yopish",
    "tk.menu.types": "Taklifnoma turlari",
    "tk.menu.language": "Til",
    "tk.footer.tagline": "Dizaynerlar yaratgan premium onlayn taklifnomalar. Toshkent, O'zbekiston.",
    "tk.footer.col.invitations": "Taklifnomalar",
    "tk.footer.col.service": "Xizmat",
    "tk.footer.col.contact": "Aloqa",
    "tk.footer.col.docs": "Hujjatlar",
    "tk.footer.offer": "Ommaviy oferta",
    "tk.footer.privacy": "Maxfiylik siyosati",
    "tk.support.open": "Yordam kerakmi?",
    "tk.support.cta": "Telegram orqali yozish",
  },
  ru: {
    "tk.dash.new": "Новое приглашение",
    "tk.dash.my": "Мои приглашения",
    "tk.dash.this_invitation": "Это приглашение",
    "tk.dash.overview": "Обзор",
    "tk.dash.wishes": "Пожелания",
    "tk.dash.link": "Ссылка",
    "tk.dash.share": "Поделиться",
    "tk.nav.home_aria": "главная",
    "tk.nav.how": "Как это работает",
    "tk.nav.pricing": "Цена",
    "tk.nav.faq": "Вопросы",
    "tk.nav.cabinet": "Кабинет",
    "tk.nav.create": "Создать приглашение",
    "tk.nav.open_menu": "Открыть меню",
    "tk.nav.close_menu": "Закрыть меню",
    "tk.menu.types": "Виды приглашений",
    "tk.menu.language": "Язык",
    "tk.footer.tagline": "Премиальные онлайн-приглашения от дизайнеров. Ташкент, Узбекистан.",
    "tk.footer.col.invitations": "Приглашения",
    "tk.footer.col.service": "Сервис",
    "tk.footer.col.contact": "Контакты",
    "tk.footer.col.docs": "Документы",
    "tk.footer.offer": "Публичная оферта",
    "tk.footer.privacy": "Политика конфиденциальности",
    "tk.support.open": "Нужна помощь?",
    "tk.support.cta": "Написать в Telegram",
  },
  en: {
    "tk.dash.new": "New invitation",
    "tk.dash.my": "My invitations",
    "tk.dash.this_invitation": "This invitation",
    "tk.dash.overview": "Overview",
    "tk.dash.wishes": "Wishes",
    "tk.dash.link": "Link",
    "tk.dash.share": "Share",
    "tk.nav.home_aria": "home",
    "tk.nav.how": "How it works",
    "tk.nav.pricing": "Pricing",
    "tk.nav.faq": "FAQ",
    "tk.nav.cabinet": "Dashboard",
    "tk.nav.create": "Create invitation",
    "tk.nav.open_menu": "Open menu",
    "tk.nav.close_menu": "Close menu",
    "tk.menu.types": "Invitation types",
    "tk.menu.language": "Language",
    "tk.footer.tagline": "Premium online invitations crafted by designers.",
    "tk.footer.col.invitations": "Invitations",
    "tk.footer.col.service": "Service",
    "tk.footer.col.contact": "Contact",
    "tk.footer.col.docs": "Legal",
    "tk.footer.offer": "Terms of service",
    "tk.footer.privacy": "Privacy policy",
    "tk.support.open": "Need help?",
    "tk.support.cta": "Message us on Telegram",
  },
};

export default dict;
